import { Component, Input, OnInit } from '@angular/core';
import { AtInternetService } from 'src/app/services/at-internet.service';

@Component({
  selector: 'app-co-branding',
  templateUrl: './co-branding.component.html',
  styleUrls: ['./co-branding.component.scss']
})
export class CoBrandingComponent implements OnInit {
  @Input() tag;
  @Input() parcelInformations;
  
  constructor(private atInternetService: AtInternetService) { }

  ngOnInit(): void {
  }
  generateTagClick() {
    this.atInternetService.generateClickAction(
      this.tag,
      'cobranding',
      'lien_banniere'
    ); 
  }
}
